
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/inventory-movements",
      function () {
        return require("private-next-pages/reports/inventory-movements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/inventory-movements"])
      });
    }
  